import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from '@blumtechgroup/blum-react-core-components';
import { CreateOrganisationUsersComponent } from '../../../../components/Global';

const CreateOrganisationUsers = (): React.ReactElement => {
  const navigate = useNavigate();

  const handleFinish = (id: string) => {
    navigate(`/org/users/${id}`);
  };

  return (
    <DashboardLayout breadcrumbs={[{ label: 'Home', link: '/org/home' }, { label: 'Users', link: `/org/users` }, { label: 'Create' }]}>
      <CreateOrganisationUsersComponent handleFinish={handleFinish} />
    </DashboardLayout>
  );
};

export default CreateOrganisationUsers;
